var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
import { __decorate, __metadata } from "tslib";
import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import { Mutations, Actions } from '@/store/enums/hrgs/master/schema/MasterSchemaListEnums';
import TMasterSchemaList from '@/core/types/entities/hrgs/master/schema/MasterSchemaList';
import PaginationType from '@/core/types/misc/Pagination';
import ApiService from '@/core/services/ApiService';
import { Actions as ErrorActions } from '@/store/enums/ErrorHandleEnum';
import { dynamicSort } from '@/core/helpers/table-sort';
const API_URL = `${process.env.VUE_APP_BASE_URL_DIGITAL}/${process.env.VUE_APP_MOBA_WEBAPI}`;
const API_URLS = {
    getAll: `${API_URL}/api/schemes`
};
let MasterSchemaListModule = class MasterSchemaListModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.pageName = 'MasterSchemaListPage';
        this.masterSchemaList = [];
        this.initMasterSchemaList = [];
        this.filteredMasterSchemaList = [];
        this.orderedMasterSchemaList = [];
        this.filterForm = {
            code: '',
            title: ''
        };
        this.initialFilterForm = Object.assign({}, this.filterForm);
        this.lastUsedFilterForm = Object.assign({}, this.filterForm);
        this.pagination = new PaginationType();
        this.loading = false;
        this.paginationLoading = false;
        this.isFiltered = false;
        this.lastOrderProp = '';
    }
    // *GETTERS
    get getMasterSchemaListIsFiltered() {
        return this.isFiltered;
    }
    get getMasterSchemaListPageName() {
        return this.pageName;
    }
    get getInitMasterSchemaList() {
        return this.initMasterSchemaList;
    }
    get getMasterSchemaList() {
        return this.masterSchemaList;
    }
    get getFilteredMasterSchemaList() {
        return this.filteredMasterSchemaList;
    }
    get getPaginationMasterSchemaList() {
        return this.pagination;
    }
    get getFilterFormMasterSchemaList() {
        return this.filterForm;
    }
    get getIsMasterSchemaListDataLoading() {
        return this.loading;
    }
    get getIsMasterSchemaListPaginationLoading() {
        return this.paginationLoading;
    }
    // *MUTATIONS
    [_a = Mutations.SET_INIT_MASTER_SCHEMA_LIST](data) {
        const newFormattedArr = data.map((element) => {
            return new TMasterSchemaList(element);
        });
        this.initMasterSchemaList = newFormattedArr;
    }
    [_b = Mutations.SET_MASTER_SCHEMA_LIST](data) {
        const newFormattedArr = data.map((element) => {
            return new TMasterSchemaList(element);
        });
        this.masterSchemaList = newFormattedArr;
    }
    [_c = Mutations.SET_FILTERED_MASTER_SCHEMA_LIST](data) {
        const newFormattedArr = data.map((element) => {
            return new TMasterSchemaList(element);
        });
        this.filteredMasterSchemaList = newFormattedArr;
    }
    [_d = Mutations.SET_ORDERED_MASTER_SCHEMA_LIST](data) {
        const newFormattedArr = data.map((element) => {
            return new TMasterSchemaList(element);
        });
        this.orderedMasterSchemaList = newFormattedArr;
    }
    [_e = Mutations.SET_LAST_ORDER_PROP](payload) {
        this.lastOrderProp = payload;
    }
    [_f = Mutations.SET_LOADING](state) {
        this.loading = state;
    }
    [_g = Mutations.SET_PAGINATION_LOADING](state) {
        this.paginationLoading = state;
    }
    [_h = Mutations.SET_PAGINATION_TOTAL_PAGE]() {
        this.pagination.totalPage = this.masterSchemaList.length;
    }
    [_j = Mutations.SET_PAGINATION_CURRENT_PAGE_CHANGE](newPage) {
        this.pagination.handleCurrentPageChange(newPage);
    }
    [_k = Mutations.SET_IS_FILTER](payload) {
        this.isFiltered = payload;
    }
    [_l = Mutations.RESET_MASTER_SCHEMA_LIST_FILTER]() {
        this.filterForm = Object.assign({}, this.initialFilterForm);
    }
    [_m = Mutations.SET_DISPLAYED_RECORDS](payload) {
        this.masterSchemaList = [];
        this.masterSchemaList.splice(0, payload.recordsLength, ...payload.records);
    }
    // *ACTIONS
    [_o = Actions.INIT_MASTER_SCHEMA_LIST](payload) {
        this.context.dispatch(Actions.GET_MASTER_SCHEMA_LIST, payload);
        this.context.commit(Mutations.SET_INIT_MASTER_SCHEMA_LIST, this.masterSchemaList);
    }
    [_p = Actions.GET_MASTER_SCHEMA_LIST](payload) {
        const url = `${API_URLS.getAll}/${payload.employeeID}?SearchValues=${this.filterForm.code}&`;
        const params = {
            SearchValues: this.filterForm.title,
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            this.context.commit(Mutations.SET_LOADING, true);
            this.context.commit(Mutations.SET_PAGINATION_LOADING, true);
            ApiService.get(`${url}${new URLSearchParams(params).toString() || ''}`)
                .then((data) => {
                const resData = data.data.result.content.sort(dynamicSort('code', 'descending'));
                this.context.commit(Mutations.SET_MASTER_SCHEMA_LIST, resData);
                this.context.commit(Mutations.SET_INIT_MASTER_SCHEMA_LIST, resData);
                this.context.commit(Mutations.SET_ORDERED_MASTER_SCHEMA_LIST, resData);
                this.context.commit(Mutations.SET_PAGINATION_TOTAL_PAGE);
                this.context.dispatch(Actions.HANDLE_CURRENT_PAGE_CHANGE, 1);
                this.context.commit(Mutations.SET_PAGINATION_CURRENT_PAGE_CHANGE, 1);
                resolve();
            })
                .catch((error) => {
                this.context.dispatch(ErrorActions.UPDATE_ERROR_TO_PAGE, {
                    page: payload.pageName,
                    type: 'unhandledError',
                    name: 'getMasterSchemaList',
                    message: error
                });
                reject();
            })
                .finally(() => {
                this.context.commit(Mutations.SET_LOADING, false);
                this.context.commit(Mutations.SET_PAGINATION_LOADING, false);
            });
        });
    }
    [_q = Actions.DELETE_LIST](payload) {
        const pageName = payload.pageName;
        const schemaID = payload.schemaID;
        const employeeID = payload.employeeID;
        const url = `${API_URLS.getAll}/${employeeID}/${schemaID}`;
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.delete(url + `?${new URLSearchParams(params).toString()}`)
                .then((res) => {
                if (res.data.result.isError) {
                    this.context.dispatch(ErrorActions.UPDATE_ERROR_TO_PAGE, {
                        page: pageName,
                        type: 'unhandledError',
                        name: 'deleteSchemaDeleteData',
                        message: res.data.errors
                    });
                }
                resolve(res.data.statusCode);
            })
                .catch((response) => {
                this.context.dispatch(ErrorActions.UPDATE_ERROR_TO_PAGE, {
                    page: pageName,
                    type: 'unhandledError',
                    name: 'deleteSchemaDeleteData',
                    message: `${response.status} - ${response.message}`
                });
                reject();
            });
        });
    }
    [_r = Actions.HANDLE_SORT_CHANGE](payload) {
        let arr = [...this.orderedMasterSchemaList];
        const prop = payload.prop;
        const order = payload.order;
        if (prop && order) {
            arr = arr.sort(dynamicSort(prop, order));
            this.context.commit(Mutations.SET_LAST_ORDER_PROP, payload.prop);
        }
        else {
            arr = arr.sort(dynamicSort(this.lastOrderProp, 'ascending'));
        }
        this.context.commit(Mutations.SET_ORDERED_MASTER_SCHEMA_LIST, arr);
        this.context.dispatch(Actions.HANDLE_CURRENT_PAGE_CHANGE_ON_SORT, this.pagination.currentPage);
    }
    [_s = Actions.HANDLE_CURRENT_PAGE_CHANGE_ON_SORT](newPage) {
        this.context.commit(Mutations.SET_PAGINATION_CURRENT_PAGE_CHANGE, newPage);
        let filtered = [...this.orderedMasterSchemaList];
        filtered = filtered.slice(this.pagination.startPaginationIndex, this.pagination.endPaginationIndex);
        this.context.commit(Mutations.SET_DISPLAYED_RECORDS, {
            recordsLength: this.pagination.totalPageSize,
            records: filtered
        });
    }
    [_t = Actions.HANDLE_CURRENT_PAGE_CHANGE](newPage) {
        this.context.commit(Mutations.SET_LOADING, true);
        this.context.commit(Mutations.SET_PAGINATION_CURRENT_PAGE_CHANGE, newPage);
        let filtered = [...this.orderedMasterSchemaList];
        filtered = filtered.slice(this.pagination.startPaginationIndex, this.pagination.endPaginationIndex);
        this.context.commit(Mutations.SET_DISPLAYED_RECORDS, {
            recordsLength: this.pagination.totalPageSize,
            records: filtered
        });
        setTimeout(() => {
            this.context.commit(Mutations.SET_LOADING, false);
        }, 300);
    }
    [_u = Actions.GET_SCHEMA_BY_ANSWERTYPE](payload) {
        const url = `${API_URLS.getAll}/${payload.employeeID}/${payload.schemaID}/answerTypes/${payload.answerTypeId}/competencyUnits?`;
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${url}${new URLSearchParams(params).toString() || ''}`)
                .then((data) => {
                const resData = data.data.result.content.sort(dynamicSort('code', 'descending'));
                resolve(resData);
            })
                .catch((error) => {
                this.context.dispatch(ErrorActions.UPDATE_ERROR_TO_PAGE, {
                    page: payload.pageName,
                    type: 'unhandledError',
                    name: 'getCompetencyUnitBySchema',
                    message: error
                });
                reject();
            });
        });
    }
    [_v = Actions.GET_SCHEMA_DETAIL_ANSWERTYPE](payload) {
        const url = `${API_URLS.getAll}/${payload.employeeID}/${payload.schemaID}/answerTypes?`;
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${url}${new URLSearchParams(params).toString() || ''}`)
                .then((data) => {
                // const resData = data.data.result.content.sort(
                //   dynamicSort("name", "descending"),
                // );
                resolve(data.data.result.content);
            })
                .catch((error) => {
                reject();
            });
        });
    }
    [_w = Actions.GET_SCHEMA_LIST](payload) {
        const filter = `SearchValues=${payload.code || ''}&SearchValues=${payload.title || ''}`;
        const url = `${API_URLS.getAll}/${payload.employeeID}?${filter}&`;
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${url}${new URLSearchParams(params).toString() || ''}`)
                .then((data) => {
                const resData = data.data.result.content.sort(dynamicSort('code', 'descending'));
                resolve(resData);
            })
                .catch((error) => {
                reject(error);
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], MasterSchemaListModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], MasterSchemaListModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterSchemaListModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterSchemaListModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterSchemaListModule.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterSchemaListModule.prototype, _f, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterSchemaListModule.prototype, _g, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MasterSchemaListModule.prototype, _h, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], MasterSchemaListModule.prototype, _j, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MasterSchemaListModule.prototype, _k, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MasterSchemaListModule.prototype, _l, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterSchemaListModule.prototype, _m, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterSchemaListModule.prototype, _o, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterSchemaListModule.prototype, _p, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterSchemaListModule.prototype, _q, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterSchemaListModule.prototype, _r, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], MasterSchemaListModule.prototype, _s, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], MasterSchemaListModule.prototype, _t, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterSchemaListModule.prototype, _u, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterSchemaListModule.prototype, _v, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterSchemaListModule.prototype, _w, null);
MasterSchemaListModule = __decorate([
    Module
], MasterSchemaListModule);
export default MasterSchemaListModule;
